import Accordion from 'Components/Molecules/Accordion/Accordion';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getEntityDisplayValue } from 'Services/helpers';
import { MODULES } from 'Services/Settings/Modules/Helper';
import { StoreState } from 'Store/Reducers';
import { getEntityIds, getEntitiesById } from 'Store/Settings/Entities/Selectors';
import FileGeneratorModuleSetting from '../FileGeneratorModuleSetting/FileGeneratorModuleSetting';

const FileGeneratorModuleSettings = ({entities, entityById, ...props}: FileGeneratorModuleSettingsProps) => {
    const [state, setState] = useState({
        isEmpty: true
    })

    useEffect(() => {
        for (const id of entities) {
            if (entityById[id]?.modules?.[MODULES.FILE_GENERATOR]) {
                setState({...state, isEmpty: false});
                break;
            }
        }
    }, []);

    return <Accordion title={'File Generator'} isOpen={true}>
        { state.isEmpty && <>Geen entiteit heeft deze module aan staan.</> }
        {
            entities?.map((id: any) => {
                if (entityById[id]?.modules && entityById[id]?.modules[MODULES.FILE_GENERATOR]) {
                    const templates = Object.entries(entityById[id]?.modules[MODULES.FILE_GENERATOR])?.filter(([_, value]) => !!value)?.map((item: any) => item[0]);

                    return <>
                        <h3>{getEntityDisplayValue(entityById[id]?.name)}</h3>
                        { templates.length == 0 && <div>Geen actieve templates gevonden...<br/><br/></div> }
                        {
                            templates?.map((template_id) => {
                                return <FileGeneratorModuleSetting
                                    entity_id={id}
                                    template_id={template_id}
                                />;
                            })
                        }
                    </>;
                }

                return <></>;
            })
        }
    </Accordion>;
}

interface Props {
    
};

const mapState = (state: StoreState) => ({
    entities: getEntityIds(state),
    entityById: getEntitiesById(state)
});

const mapDispatch = {
};

type FileGeneratorModuleSettingsProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(FileGeneratorModuleSettings);